import React, {useState, useEffect} from 'react';
import SubSection from '../../libs/react-components-admin/section/sub-section';

const FormPanel = ({value, onChange}) => {

  const [model, setModel] = useState(value || {enabled: false});

  useEffect(() => {
    onChange(model.enabled ? model : {enabled: false});
  }, [model]);

  useEffect(() => {
    if ((value || {}).enabled != null && model.enabled !== value.enabled) {
      setModel({...model, enabled: value.enabled});
    }
  }, [(value || {}).enabled]);

  const title = <div className="form-check">
    <input type="checkbox"
           id="form-panel-enabled"
           className="form-check-input"
           style={{width: '0.8em', height: '0.8em', marginTop: '5px'}}
           checked={!!model.enabled}
           onChange={e => setModel({...model, enabled: e.target.checked})} />
    <label className="form-check-label" htmlFor="form-panel-enabled" style={{cursor: 'pointer'}}>
      Display the form in a panel
    </label>
  </div>;
  return <SubSection title={title}/>;
};

export default FormPanel;
